<template lang="pug">
  .layout-view__controls
    template(v-if="!isMobile")
      v-datepicker.mr-3(
        position-left
        v-model="date")

      v-btn(
        medium
        :disabled="!hasPermission('schedule', 'add', 'animalfeed')"
        @click="$emit('open-create')")
        v-icon(
          position-left
          font-size="1"
          icon="plus")
        span {{ 'base.add_preparation_to_schedule' | translate }}

    template(v-else)
      v-datepicker(
        position-left
        v-model="date")
      v-btn(
        fab
        @click="$emit('open-create')")
        v-icon(
          font-size="1.2"
          icon="plus")
      
    v-dialog(
      max-width="380"
      :value="showEditDialog"
      @input="unsetCurrentSchedule")
      edit-planning-modal(
        @close="unsetCurrentSchedule")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import { getDateForDatePicker } from '@/util'
import adaptationMixin from '@/mixins/adaptation.mixin.js'

import EditPlanningModal from './modals/EditPlanningModal'

export default {
  name: 'ControlsPanel',

  mixins: [adaptationMixin],

  components: {
    EditPlanningModal
  },

  mounted () {
    this.date = getDateForDatePicker(this.timezone)
    this.loadData()
  },

  data: () => ({
    modals: {
      showEditPlanning: true
    },
    date: null
  }),

  methods: {
    ...mapActions('animalfeed', [
      'loadSchedules',
      'unsetCurrentSchedule'
    ]),

    loadData () {
      const params = {
        farm: this.$route.params.farm_id,
        planned_on: this.date.substring(0, 10)
      }
      this.loadSchedules(params)
    }
  },

  computed: {
    ...mapGetters('animalfeed', [
      'currentSchedule'
    ]),
    timezone () {
      return this.$store.getters['account/timezone']
    },
    showEditDialog () {
      return this.currentSchedule !== null
    }
  },

  watch: {
    date (value) {
      this.loadData()
    }
  }
}
</script>
